import { getProjectId } from '@appmaker/core/store/project';
import { useEffect } from 'react';

const BlockEditor = () => {
	const projectId = getProjectId();
	useEffect(() => {
		window.location.href = `https://manage-v2.appmaker.xyz/apps/${projectId}/inAppPage/home`;
	}, [projectId]);
	return null;
};

export default BlockEditor;
